import React, { useState } from "react";
import "./index.css";

const NicknamePrompt = ({ onSubmit }) => {
  const [nickname, setNickname] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedNickname = nickname.trim();
    if (trimmedNickname !== "") {
      onSubmit(trimmedNickname);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <div className="nickname-container">
      <div className="nickname-card">
        <h2 className="nickname-title">Join Chat Room</h2>
        <p className="nickname-subtitle">Enter your nickname to continue</p>
        <input
          className="nickname-input"
          type="text"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Your nickname"
          maxLength={20}
          autoFocus
        />
        <button
          className="nickname-button"
          onClick={handleSubmit}
          disabled={nickname.trim() === ""}
        >
          Join Room
        </button>
      </div>
    </div>
  );
};

export default NicknamePrompt;
